import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail } from "lucide-react";

const fields = [
  ["name", "Full name", "text", "Priya Sharma", true],
  ["email", "Email", "email", "priya@email.com", true],
  ["phone", "Phone (optional)", "tel", "+91 98xxx xxxxx"],
  ["city", "City (optional)", "text", "Bengaluru"],
];

export default function DetailsStep({ client, setClient, user }) {
  return (
    <div data-testid="details-step" className="max-w-2xl">
      <p className="text-sm text-brand-muted mb-6">
        We'll personalise your quotation. {user ? "It will be saved to your account automatically." : "No account needed — sign in later to save it."}
      </p>
      <div className="grid sm:grid-cols-2 gap-5">
        {fields.map(([k, l, t, ph, req]) => (
          <div key={k} className="space-y-2">
            <Label htmlFor={k} className="text-brand-ink">{l}{req && <span className="text-brand-accent"> *</span>}</Label>
            <Input id={k} type={t} required={req} placeholder={ph} value={client[k]} onChange={(e) => setClient({ ...client, [k]: e.target.value })}
              className="h-12 bg-brand-cream border-brand-line focus-visible:ring-brand-accent" data-testid={`client-${k}-input`} />
          </div>
        ))}
      </div>
      <p className="mt-6 inline-flex items-start gap-2 text-xs text-brand-muted bg-brand-sand rounded-xl px-4 py-3" data-testid="email-notice">
        <Mail className="w-4 h-4 text-brand-accent shrink-0" /> Your PDF quotation will be emailed to this address the moment it's ready.
      </p>
    </div>
  );
}
